import { render } from "./ShoppingListSearchResultPage.vue?vue&type=template&id=74107acc&scoped=true&ts=true"
import script from "./ShoppingListSearchResultPage.vue?vue&type=script&lang=ts"
export * from "./ShoppingListSearchResultPage.vue?vue&type=script&lang=ts"

import "./ShoppingListSearchResultPage.vue?vue&type=style&index=0&id=74107acc&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74107acc"]])

export default __exports__